import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import { collectNodes } from '@kdcloudjs/table/es/table/utils';
import { rangeSelectionKey } from '@kdcloudjs/table/es/table/pipeline/features/rangeSelection';
export default function getApi(pipelineRef) {
  function getColumns() {
    var _a;
    return (_a = pipelineRef.current.getColumns) === null || _a === void 0 ? void 0 : _a.bind(pipelineRef.current)();
  }
  function getDataSource() {
    var _a;
    return (_a = pipelineRef.current.getDataSource) === null || _a === void 0 ? void 0 : _a.bind(pipelineRef.current)();
  }
  function getFooterDataSource() {
    var _a;
    return (_a = pipelineRef.current.getFooterDataSource) === null || _a === void 0 ? void 0 : _a.bind(pipelineRef.current)();
  }
  /**
   * 清除范围选中内容
   */
  function clearRangeSelection() {
    var pipeline = pipelineRef.current;
    pipeline.setStateAtKey(rangeSelectionKey, null);
  }
  /**
   * 将目标行滚动到可视位置
   * @param rowIndex 行索引
   * @param position 目标行滚动到的位置，不传则根据目标行相对视口的位置滚动到底部或顶部，可取值为'top' | 'middle' | 'bottom'
   * @returns
   */
  function ensureRowIndexVisible(rowIndex, position) {
    var _a, _b;
    var pipeline = pipelineRef.current;
    var _ref = (_a = pipeline.ref) === null || _a === void 0 ? void 0 : _a.current.rowHeightManager,
      cache = _ref.cache;
    if (typeof rowIndex !== 'number' || rowIndex < 0 || rowIndex >= cache.length) {
      console.warn('invalid row index for ensureIndexVisible: ' + rowIndex);
      return;
    }
    var tableBodyContainer = (_b = pipeline.ref) === null || _b === void 0 ? void 0 : _b.current.domHelper.tableBody;
    if (!tableBodyContainer) return;
    var rowTopPixel = 0;
    for (var i = 0; i < rowIndex; i++) {
      rowTopPixel += cache[i];
    }
    var rowBottomPixel = rowTopPixel + cache[rowIndex];
    var viewportHeight = tableBodyContainer.clientHeight;
    var vScrollTop = tableBodyContainer.scrollTop;
    var vScrollBottom = vScrollTop + viewportHeight;
    var pxTop = rowTopPixel;
    var pxBottom = rowBottomPixel - viewportHeight;
    var pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
    var rowBelowViewport = vScrollTop > rowTopPixel;
    var rowAboveViewport = vScrollBottom < rowBottomPixel;
    var newScrollPosition = null;
    if (position === 'top') {
      newScrollPosition = pxTop;
    } else if (position === 'bottom') {
      newScrollPosition = pxBottom;
    } else if (position === 'middle') {
      newScrollPosition = pxMiddle;
    } else if (rowBelowViewport) {
      // 目标行在视口之上，则向上滚动到顶部
      newScrollPosition = pxTop;
    } else if (rowAboveViewport) {
      // 目标行在视口之下，则向下滚动到底部
      newScrollPosition = pxBottom;
    }
    if (newScrollPosition !== null) {
      tableBodyContainer.scrollTop = newScrollPosition;
    }
  }
  /**
   * 将目标列滚动到可视位置
   * @param code 列标识
   * @returns
   */
  function ensureColumnVisible(code) {
    var _a, _b, _c, _d;
    var pipeline = pipelineRef.current;
    var tableBodyContainer = (_a = pipeline.ref) === null || _a === void 0 ? void 0 : _a.current.domHelper.tableBody;
    var tableScroll = (_b = pipeline.ref) === null || _b === void 0 ? void 0 : _b.current.domHelper.stickyScroll;
    var columnNodes = collectNodes(pipeline.getColumns(), 'leaf-only');
    var column = _findInstanceProperty(columnNodes).call(columnNodes, function (col) {
      return col.code === code;
    });
    var index = _findIndexInstanceProperty(columnNodes).call(columnNodes, function (col) {
      return col.code === code;
    });
    // 固定列也不需要重置滚动条
    if (!column || !tableBodyContainer || (column === null || column === void 0 ? void 0 : column.lock)) return;
    var colLeft = _sliceInstanceProperty(columnNodes).call(columnNodes, 0, index).reduce(function (acc, col) {
      return acc + col.width;
    }, 0);
    var lockColumnLeft = 0;
    var lockColumnRight = 0;
    for (var i = 0; i < columnNodes.length; i++) {
      if ((_c = columnNodes[i]) === null || _c === void 0 ? void 0 : _c.lock) {
        lockColumnLeft += columnNodes[i].width;
      } else {
        break;
      }
    }
    for (var _i = columnNodes.length - 1; _i >= 0; _i--) {
      if ((_d = columnNodes[_i]) === null || _d === void 0 ? void 0 : _d.lock) {
        lockColumnRight += columnNodes[_i].width;
      } else {
        break;
      }
    }
    var colLeftPixel = colLeft; // 目标列前面列宽总和
    var colRightPixel = colLeftPixel + column.width;
    var viewportWidth = tableBodyContainer.clientWidth; // 表体容器的宽度
    var scrollPosition = tableScroll.scrollLeft; // 滚动条滚动的距离
    var vScrollLeft = scrollPosition;
    var vScrollRight = scrollPosition + viewportWidth;
    var pxLeft = colLeftPixel - lockColumnLeft;
    var pxRight = colRightPixel - viewportWidth + lockColumnRight;
    var colBeforeViewport = vScrollLeft > colLeftPixel; // 滚动距离大于目标列前面列宽总和，说明目标列在视口之前
    var colPastViewport = vScrollRight < colRightPixel; // 目标列是视口之后
    var colToSmallForViewport = viewportWidth < column.width;
    var alignColToLeft = colBeforeViewport || colToSmallForViewport;
    var alignColToRight = colPastViewport;
    if (alignColToLeft || alignColToRight) {
      var newScrollPosition = alignColToLeft ? pxLeft : pxRight;
      tableScroll.scrollLeft = newScrollPosition;
    }
  }
  function getHeightCache() {
    var _a;
    var pipeline = pipelineRef.current;
    return (_a = pipeline.ref) === null || _a === void 0 ? void 0 : _a.current.rowHeightManager.cache;
  }
  return {
    getColumns: getColumns,
    getDataSource: getDataSource,
    getFooterDataSource: getFooterDataSource,
    clearRangeSelection: clearRangeSelection,
    ensureRowIndexVisible: ensureRowIndexVisible,
    ensureColumnVisible: ensureColumnVisible,
    getHeightCache: getHeightCache
  };
}